<template>
  <CSidebar :minimize="minimize" unfoldable :show="show" @update:show="value => $store.commit('set', ['sidebarShow', value])">
    <CSidebarMinimizer class="c-d-md-down-none" @click.native="$store.commit('toggle', 'sidebarMinimize')" />
    <CRenderFunction flat :contentToRender="sidebarItems" />
    <CSidebarMinimizer class="c-d-md-down-none" @click.native="$store.commit('toggle', 'sidebarMinimize')" />
  </CSidebar>
</template>

<script>
import SidebarItems from './SidebarItems'
export default {
  name: 'TheSidebar',
  extends: SidebarItems,
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
  },
}
</script>

<style lang="scss">
.customClasses {
  background: red;
}
</style>
